<div *ngIf="productService.activeItem">
  <div>
    <mat-horizontal-stepper #stepper [linear]="true" labelPosition="bottom"
      class="stepper-container stepper-disabled-steps">
      <mat-step [completed]="isDetailsStepComplete()">
        <ng-template matStepLabel>Grunddaten</ng-template>
        <div class="form-header">
          <h1>{{ formTitle }}</h1>
        </div>
        <div class="auto-min">
          <mat-form-field>
            <input matInput placeholder="Hersteller" [value]="organisationService.activeItem.organisationName"
              disabled />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Produktkategorie</mat-label>
            <mat-select [value]="selectedCategoryValue" (valueChange)="setProductEditCategory($event)"
              #productCategorySelect="matSelect" required>
              <mat-option *ngFor="let category of categories" [value]="category.value">
                {{ category.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <form #form="ngForm">
          <mat-form-field class="product-name" hintLabel="Keine schon vorhandenen Produktnamen oder Sonderzeichen">
            <mat-label>Produktname</mat-label>
            <input matInput [(ngModel)]="productEdit.name" [(value)]="productEdit.name" required name="productName"
              [errorStateMatcher]="productNameErrorStateMatcher" maxlength="161" minlength="2"
              #productNameCtrl="ngModel" [ngModelOptions]="{ updateOn: 'change' }"
              (blur)="productEdit.name = productEdit.name.trim()" />
            <mat-error>
              {{ utilService.getErrorMessage(productNameCtrl, {includeMinLength: true, fieldName: 'Produkt'}) }}
            </mat-error>
          </mat-form-field>
          <app-text-editor [(editorText)]="productEdit.description"
            (textValidityChange)="onDescriptionValidityChange($event)">
          </app-text-editor>

          <!-- <div class="prio-container" *ngIf="isProductListed">
                  <p>
                      Soll dieses Produkt priorisiert dargestellt werden?
                  </p>
                  <toggle-switch
                      [trueLabel]="'Ja'"
                      [falseLabel]="'Nein'"
                      [value]="prioritizedProduct"
                      [allowUndefined]="false"
                      [disableToggle]="!isProductListed"
                      (valueChange)="changePrioritizedProductValue($event)"
                  >
                  </toggle-switch>
              </div>
              <br /> -->
          <mat-form-field class="url">
            <mat-label>Link zur Produktwebsite</mat-label>
            <input matInput [(ngModel)]="productEdit.url" required [value]="fetchedProduct.url" name="url"
              #productURL="ngModel" appUrlValidator type="url" />
            <mat-error *ngIf="productURL.errors?.required">
              Diese Angabe ist erforderlich
            </mat-error>
            <mat-error *ngIf="productURL.hasError('websiteLength')">
              Die Website darf maximal 60 Zeichen lang sein
            </mat-error>
            <mat-error *ngIf="productURL.hasError('invalidUrl') && !productURL.hasError('websiteLength')">
              Bitte eine valide URL angeben
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field>
                  <input
                      matInput
                      placeholder="Slogan"
                      [(ngModel)]="productEdit.slogan"
                      [value]="productEdit.slogan"
                      name="slogan"
                  />
              </mat-form-field> -->
          <addEntriesToList-panel [(keywords)]="productEdit.features" [editable]="true" [keywordPanel]="false">
          </addEntriesToList-panel>
          <div class="product-dependency">
            <h3>Produktabhängigkeit</h3>
            <app-add-product-dependency-panel [product]="productEdit"
              [isCreate]="false"></app-add-product-dependency-panel>
            <app-selected-product-panel [hidden]="productEdit.relatedProducts.length === 0" [product]="productEdit">
            </app-selected-product-panel>
          </div>
          <div class="mini-grid-buttons">
            <span class="info-txt">*Pflichtfeld</span>
            <button matButton="elevated" color="warn" (click)="onCancelEdit()" style="margin-top: 1vw;">
              Abbrechen
            </button>
            <div></div>
            <div></div>
            <button matButton="elevated" class="green-confirm" [disabled]="!isDetailsStepComplete()"
              (click)="stepper.next()" style="margin-top: 1vw;">
              Weiter
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step [completed]="productEdit?.fileId">
        <ng-template matStepLabel>Gallerie & Dateien</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <div></div>
          <button matButton="elevated" color="accent" (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>
        </div>

        <div>
          <app-logo [fileId]="productEdit.fileId" (logoChanged)="productEdit.fileId = $event"
            [fullView]="true"></app-logo>
          <app-product-files [documentFileIds]="productEdit.documentFileIds"
            [galleryFileIds]="productEdit.galleryFileIds" [logoId]="productEdit.fileId"
            [galleryTitle]="'Produktgalerie'" (logoChanged)="productEdit.fileId = $event"></app-product-files>
        </div>

        <div class="mini-grid-buttons">
          <span class="info-txt">*Pflichtfeld</span>
          <button matButton="elevated" color="warn" (click)="onCancelEdit()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <button matButton="elevated" color="accent" (click)="stepper.previous()" style="margin-top: 1vw;">
            Zurück
          </button>
          <button matButton="elevated" class="green-confirm" [disabled]="!isGalleryStepComplete()"
            (click)="stepper.selectedIndex = 3" style="margin-top: 1vw;">
            Weiter
          </button>
        </div>
      </mat-step>

      <!-- Step 3: visible, not clickable -->
      <mat-step [editable]="false" [completed]="true">
        <ng-template matStepLabel>Variante & Versionen</ng-template>
        <div class="step-disabled-info">Dieser Schritt ist deaktiviert.</div>
      </mat-step>

      <mat-step [completed]="isCommonFeatureStepValid()">
        <ng-template matStepLabel>Übergeordnete Auswahlkriterien</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <div></div>
          <button matButton="elevated" color="accent" (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>
        </div>

        <div class="commonFeatureSelection" *ngIf="features$ | async as features">
          <app-common-feature-product-creation [selected]="commonFeatures" [selectedCategory]="selectedCategory?.name"
            (selectedChange)="onCommonFeaturesChanged($event)">
          </app-common-feature-product-creation>
        </div>

        <div class="mini-grid-buttons">
          <span class="info-txt">*Pflichtfeld</span>
          <button matButton="elevated" color="warn" (click)="onCancelEdit()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <button matButton="elevated" class="green-confirm" (click)="stepper.selectedIndex = 1"
            style="margin-top: 1vw;">Zurück</button>
          <button matButton="elevated" class="green-confirm" (click)="stepper.next()" style="margin-top: 1vw;"
            [disabled]="!isCommonFeatureStepValid()">Weiter</button>
        </div>
      </mat-step>



      <mat-step>
        <ng-template matStepLabel>Zusammenfassung</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <button id="savebtn" matButton="elevated" color="accent" [disabled]="isSaveDisabled()"
            (click)="createProduct()">
            Speichern
          </button>
          <button matButton="elevated" color="accent" [disabled]="!isDetailsStepComplete()"
            (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>
        </div>

        <p class="info-text"><em>Bitte drücken Sie den Vorschau-Button um die Änderungen zu prüfen.</em></p>

        <div class="mini-grid-buttons">
          <span class="info-txt">*Pflichtfeld</span>
          <button matButton="elevated" color="warn" (click)="onCancelEdit()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <div></div>
          <button matButton="elevated" class="green-confirm" style="margin-top: 1vw;"
            (click)="stepper.previous()">Zurück</button>
        </div>
      </mat-step>


    </mat-horizontal-stepper>
  </div>
</div>